import * as React from 'react';

const ElectronicsBadgeFilled16 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.698 1.484 9.687.622a2.6 2.6 0 0 0-3.376 0L5.3 1.484l-1.325.105a2.6 2.6 0 0 0-2.387 2.387l-.106 1.325L.62 6.312a2.6 2.6 0 0 0 0 3.376l.862 1.011.106 1.325a2.6 2.6 0 0 0 2.387 2.387l1.325.106 1.011.861a2.6 2.6 0 0 0 3.376 0l1.011-.861 1.325-.106a2.6 2.6 0 0 0 2.386-2.387l.106-1.325.862-1.011a2.6 2.6 0 0 0 0-3.376l-.862-1.011-.106-1.325a2.6 2.6 0 0 0-2.386-2.387zM4.541 9.312a4.03 4.03 0 0 1 .387-3.73.75.75 0 0 1 1.244.837 2.53 2.53 0 0 0-.24 2.331c.36.892 1.237 1.5 2.18 1.5.941 0 1.818-.608 2.178-1.5a2.53 2.53 0 0 0-.24-2.331.75.75 0 1 1 1.244-.838 4.03 4.03 0 0 1 .387 3.731c-.58 1.434-1.99 2.438-3.57 2.438s-2.99-1.004-3.57-2.438M8.858 4.5v2a.75.75 0 1 1-1.5 0v-2a.75.75 0 0 1 1.5 0"
  }
));
ElectronicsBadgeFilled16.Size = 16;
ElectronicsBadgeFilled16.Title = "ElectronicsBadgeFilled";

export { ElectronicsBadgeFilled16 as default };
